import { useEffect, useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { crearAyudantia } from '../../store/slices/ayudantia';
// LaTeX
import Latex from 'react-latex-next';
// mui components
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  open: boolean
  setOpen: any
}

const CrearEjercicioAyudantia = ({ open, setOpen }: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { curso } = useSelector((state: RootState) => state.curso);
  const { modulo } = useSelector((state: RootState) => state.modulo);
  const { ayudantias } = useSelector((state: RootState) => state.ayudantia);

  const [enunciado, setEnunciado] = useState('');
  const [solucion, setSolucion] = useState('');

  const [error, setError] = useState('');

  useEffect(() => {
    if (error !== '') {
      const timer = setTimeout(() => { setError(''); }, 3000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const handleCrearAyudantia = () => {

    if (enunciado === '') {
      return setError('Ingresa el enunciado del ejercicio')
    }

    if (solucion === '') {
      return setError('Ingresa la solución del ejercicio')
    }

    if (curso.cid && enunciado !== '') {
      const nuevoEjercicio = {
        id: '',
        cid: curso.cid,
        mid: modulo.mid,
        numero: ayudantias.length + 1,
        enunciado: enunciado,
        solucion: solucion,
      }
      dispatch(crearAyudantia(nuevoEjercicio));
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      fullScreen
    >
      <DialogTitle>
        Crear Ejercicio de Ayudantía
      </DialogTitle>
      <DialogContent>

        {
          error &&
          <div className="alert alert-danger" style={{ position: 'absolute', bottom: 5, left: 20, padding: 5 }}>
            {error}
          </div>
        }

        <div className="container my-5">
          <div className="row">
            <div className="col-6">

              <TextField
                id="outlined-multiline-static"
                label="Enunciado"
                multiline
                rows={10}
                // defaultValue="Default Value"
                value={enunciado}
                onChange={(e: any) => setEnunciado(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-6">
              <div className='card'>
                <div className="card-header">
                  Ejercicio
                </div>
                <div className="card-body" style={{ minHeight: '195px' }}>
                  <Latex>{enunciado}</Latex>
                </div>
              </div>
            </div>
          </div>

          <div className="row my-5">
            <div className="col-6">
              <TextField
                id="outlined-multiline-static"
                label="Solución"
                multiline
                rows={10}
                // defaultValue="Default Value"
                value={solucion}
                onChange={(e: any) => setSolucion(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-6">
              <div className='card'>
                <div className="card-header">
                  Solución
                </div>
                <div className="card-body" style={{ minHeight: '195px' }}>
                  <Latex>{solucion}</Latex>
                </div>
              </div>
            </div>
          </div>
        </div>

      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>Cancelar</Button>
        <Button onClick={() => handleCrearAyudantia()}>Crear</Button>
      </DialogActions>
    </Dialog>
  )

}

export default CrearEjercicioAyudantia;